import type { Action, ThunkAction } from "@reduxjs/toolkit";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import errorMiddleware from "./errorSlice/middleware";
import userReducer from './userSlice/userSlice'
import errorReducer from "./errorSlice";

import { api } from "./apiSlice";

const reducer = combineReducers({
  [api.reducerPath]: api.reducer,
  user: userReducer,
  errors: errorReducer,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([api.middleware, errorMiddleware]),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof reducer>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
